import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ItemComponent from './item';
import datalistMixins from './mixins';

export default createReactClass({
	propTypes: {
		data: PropTypes.object
	},

	mixins: [datalistMixins],

	getTotal() {
		let totalClass = 'slx-datalist__li slx-datalist__total';
		if (this.state.current === this.props.data.results.length) {
			totalClass += ' active';
		}
		if (this.props.data.total <= 0) {
			return (
				<li className={totalClass}>
					{this.props.data.none}
				</li>
			);
		}
		return (
			<li className={totalClass}>
				<a href={this.props.data.url}>
					{this.props.data.show}
				</a>
			</li>
		);
	},

	renderItem(result, i) {
		return <ItemComponent data={result} key={result.title} active={this.state.current === i} />;
	},

	render() {
		return (
			<div>
				<ul className="slx-datalist__ul">
					{this.props.data.results.map(this.renderItem)}
				</ul>
			</div>
		);
	}
});
